import { UserRoleType } from "@/constants/auth";
import { getToken } from "@/utils/auth";
import { decodeJWTToken } from "./token.utils";

/**
 * Oturumdaki access token'ın rol tipleri (backend `JwtPayload.roleTypes`).
 *
 * Store'daki `userType` yalnızca en yüksek öncelikli tipi taşır ve
 * EDUCATION_MANAGER, CENTRAL_MANAGER'dan önce gelir; iki rolü birden olan
 * kullanıcı Sistem Yöneticisi olarak görünmez. Tüm liste token'dan okunur.
 */
export function getSessionRoleTypes(): number[] {
  const token = getToken();
  if (!token) return [];
  const raw = decodeJWTToken(token)?.roleTypes;
  if (!Array.isArray(raw)) return [];
  return raw.map(Number).filter((n) => !Number.isNaN(n));
}

/** Oturum Sistem Yöneticisi (CENTRAL_MANAGER) rolüne sahip mi? */
export function isCentralManagerSession(): boolean {
  return getSessionRoleTypes().includes(UserRoleType.CENTRAL_MANAGER);
}
